var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'screen-link '+ _vm.dotClass,style:(_vm.linkStyle),attrs:{"data-active":"active","data-show-dot":_vm.showDot}},[(_vm.href)?_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }